import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";


const State = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);
    
    let response32 = useInvoke("WebApps", "32", {});

    useEffect(() => {

        //get states
            if (response32.data.payload != undefined) {
                let myData = JSON.parse(response32.data.payload).data;
                let rowsList = [];

                myData.forEach((entry, index) => { 

                let row = [
                    {type: "link", content: {text: `${entry[1]}`, link: `/State/Edit/${entry[0]}`}}, 
                    {type: "text", content: {text: `${entry[2]}`}},
                    {type: "text", content: {text: `${entry[3]}`}},
                    {type: "text", content: {text: `${entry[4]}`}},

                ];
                rowsList.push(row);
                });
                setColumns(["State", "Abbr", "Country", "Date Added"]);
                setRows(rowsList);
            }

    }, [response32.data.payload]);

    document.title = "States / Provinces";
    return ( 
        <div className="states">
            {(user["email"] != undefined && response32.isPending == false) && 
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>States / Provinces</h2>
                        <p><Link className="btn btn-primary" to="/State/New">New State</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
            
        </div>
     );
}
 
export default State;